var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c(
        "modal",
        {
          attrs: { title: "Eventos do pedido", size: "md" },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", [
              _c(
                "ul",
                _vm._l(_vm.orderEvents, function(event, index) {
                  return _c("li", { key: index }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          event.created_at.format("DD MMMM YYYY,HH:mm:ss")
                        ) +
                        " -\n          " +
                        _vm._s(
                          _vm._f("getStatusName")(
                            _vm.event_name(event.event_type)
                          )
                        ) +
                        "\n          "
                    ),
                    event.description != null && event.description !== ""
                      ? _c("div", { attrs: { id: "description" } }, [
                          _c("strong", { staticClass: "pl-4" }, [
                            _vm._v("Descrição:")
                          ]),
                          _vm._v(
                            " " + _vm._s(event.description) + "\n          "
                          )
                        ])
                      : _vm._e()
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn bg-purple-outline",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("\n      fechar\n    ")]
            )
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3062acf7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3062acf7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/Events/Events.vue
// module id = null
// module chunks = 